import { Pipe, PipeTransform } from '@angular/core';
import {
  Partners,
  QuoteType,
  QuoteWorkflowStatus,
} from '@lockton-apps/shared/interfaces';

import { WorkflowStatusQueueMeta } from './core/interface';
import { getStatusQueueMeta } from './core/status-queue-workflow-meta';

@Pipe({
  name: 'statusQueueMeta',
  standalone: true,
})
export class StatusQueueMetaPipe implements PipeTransform {
  transform(
    status: QuoteWorkflowStatus,
    quoteType: QuoteType,
    partner?: Partners
  ): WorkflowStatusQueueMeta {
    return getStatusQueueMeta(status, quoteType, partner);
  }
}
